import { AntragObj } from '../../../api/models/Antrag/AntragsModel';
import ZuweisungTeamleiter from './ZuweisungTeamleiter';
import ZuweisungSachbearbeiter from './ZuweisungSachbearbeiter';
import { CaseDetailsModel } from '../../../api/models/Case/CaseDetailsModel';
import type { ButtonProps } from '@efast_public/fjd-component-library';
import { Property } from 'csstype';
import { useMemo } from 'react';
import { useProfile } from 'shared/hooks/AuthContext';

export interface ZuweisungComponentConfig {
  readonly antrag: AntragObj | CaseDetailsModel;
  readonly isSchreibtisch: boolean;
  readonly position?: Property.Position;
  readonly marginBottom?: string | undefined;
  readonly buttonSize?: ButtonProps['size'];
}
function ZuweisungComponent(props: ZuweisungComponentConfig): JSX.Element {
  const { hasRole } = useProfile();

  const isTeamleiter = useMemo(() => hasRole(`Teamleitung`), [hasRole]);

  return isTeamleiter ? (
    <ZuweisungTeamleiter
      antragObj={props.antrag}
      marginBottom={props.marginBottom}
      position={props.position}
    />
  ) : (
    <ZuweisungSachbearbeiter
      antragObj={props.antrag}
      isSchreibtisch={props.isSchreibtisch}
      buttonSize={props.buttonSize}
    />
  );
}
export default ZuweisungComponent;
